/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Basic_Included2Inputs */

const ja_playdata_pricing_basic_included2 = /** @type {(inputs: Playdata_Pricing_Basic_Included2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4日目以降は追加料金5,000円/日が加算`)
};

const en_playdata_pricing_basic_included2 = /** @type {(inputs: Playdata_Pricing_Basic_Included2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional days: ¥5,000/day`)
};

/**
* | output |
* | --- |
* | "Additional days: ¥5,000/day" |
*
* @param {Playdata_Pricing_Basic_Included2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_basic_included2 = /** @type {((inputs?: Playdata_Pricing_Basic_Included2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Basic_Included2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_basic_included2(inputs)
	return en_playdata_pricing_basic_included2(inputs)
});